var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 1212.6879,
    height: 336.61346,
    viewBox: "0 0 1212.6879 336.61346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,960 H 960 V 0 H 0 Z",
    id: "path16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,-43.244159,1269.2789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(197.81712,854.75497)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.649,-27.661 0.649,-47.337 0,-59.026 -14.676,-15.064 -40.454,-22.596 -77.335,-22.596 -30.909,0 -53.765,7.793 -68.569,23.378 -12.988,13.634 -19.48,32.53 -19.48,56.684 0,23.766 6.687,42.468 20.064,56.104 15.064,15.321 37.724,23.376 67.985,24.154 13.246,0.259 26.426,-1.039 39.544,-3.895 7.793,-2.209 15.585,-4.416 23.376,-6.625 1.686,-0.778 2.532,-1.947 2.532,-3.504 V 32.921 c -0.261,-1.559 -1.168,-2.079 -2.726,-1.559 -12.729,12.597 -22.013,20.844 -27.857,24.739 -11.688,7.662 -24.545,11.494 -38.571,11.494 -17.014,0 -30.065,-5.843 -39.153,-17.532 -8.055,-10.39 -12.079,-23.961 -12.079,-40.712 0,-20.911 5.714,-39.092 17.143,-54.545 12.595,-17.273 29.09,-25.909 49.479,-25.909 3.506,0 7.077,0.259 10.713,0.779 5.584,0.908 10.39,3.215 14.416,6.917 4.023,3.7 6.039,8.016 6.039,12.954 v 6.624 c 0,13.246 -0.716,21.945 -2.143,26.102 -2.988,8.31 -10.196,13.568 -21.622,15.779 -0.652,0.127 -0.974,0.454 -0.974,0.974 0,0.518 0.258,0.842 0.778,0.974 z",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g24",
    transform: "translate(295.01902,854.16917)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -18.701,14.806 c -2.989,2.338 -6.106,2.985 -9.35,1.948 -7.275,-2.468 -10.976,-9.222 -11.104,-20.259 l -0.194,-32.143 c 0,-12.987 0.711,-21.493 2.142,-25.518 2.855,-8.313 9.804,-13.507 20.844,-15.585 0.648,-0.129 0.974,-0.456 0.974,-0.973 0,-0.52 -0.263,-0.842 -0.78,-0.974 h -71.686 c -0.517,0.132 -0.778,0.454 -0.778,0.974 0,0.517 0.325,0.844 0.973,0.973 7.402,1.428 12.206,7.337 14.416,17.728 0.906,4.545 1.363,12.336 1.363,23.375 v 30 c 0,12.856 -0.652,21.167 -1.948,24.935 -2.989,7.918 -9.935,12.919 -20.843,14.999 -0.649,0.127 -0.975,0.454 -0.975,0.974 0,0.517 0.262,0.778 0.78,0.778 h 55.518 V 13.441 c 5.713,15.585 17.531,23.378 35.453,23.378 1.818,0 3.765,-0.068 5.844,-0.195 5.193,-0.52 9.575,-2.47 13.149,-5.846 C 18.667,27.4 20.454,23.31 20.454,18.506 20.454,7.598 13.635,1.428 0,0",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(351.41222,924.20017)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.184,3.051 -4.773,6.915 -4.773,11.591 0,4.545 1.589,8.377 4.773,11.494 3.18,3.117 7.043,4.674 11.59,4.674 4.545,0 8.377,-1.591 11.494,-4.772 3.117,-3.185 4.675,-6.983 4.675,-11.396 0,-4.547 -1.558,-8.376 -4.675,-11.493 C 19.967,-3.019 16.135,-4.576 11.59,-4.576 7.043,-4.576 3.18,-3.053 0,0 m 52.304,-147.755 c 0,-0.52 -0.326,-0.779 -0.974,-0.779 l -73.635,-0.195 c -0.52,0.131 -0.779,0.454 -0.779,0.974 0,0.517 0.322,0.844 0.974,0.973 7.403,1.428 12.205,7.337 14.415,17.728 0.907,4.413 1.364,12.077 1.364,22.987 v 29.219 c 0,12.726 -0.716,21.166 -2.143,25.323 -2.857,8.311 -9.676,13.507 -20.454,15.584 -0.651,0.13 -1.041,0.454 -1.168,0.974 0,0.518 0.322,0.845 0.974,0.974 h 57.66 v -71.686 c 0,-12.855 0.712,-21.3 2.143,-25.323 2.855,-8.443 9.673,-13.702 20.453,-15.78 0.649,0 1.039,-0.324 1.17,-0.973",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(457.48022,879.69007)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -67.598 c 6.492,-18.572 15.322,-27.854 26.493,-27.854 2.075,0 4.155,0.388 6.233,1.169 9.868,3.764 14.806,14.867 14.806,33.31 0,6.36 -0.652,13.246 -1.949,20.649 -1.948,11.298 -5.585,20.678 -10.908,28.147 C 29.348,-4.711 23.504,-0.652 17.143,0 Z m 66.232,-6.041 c 8.961,-10 13.441,-23.637 13.441,-40.908 0,-17.402 -4.286,-30.971 -12.857,-40.712 -10.002,-11.298 -25.391,-16.946 -46.167,-16.946 -7.403,0 -14.287,2.399 -20.649,7.207 v -23.961 -10.715 c 0,-8.181 -4.547,-17.4 -13.635,-27.661 -9.612,-10.908 -20.065,-17.725 -31.363,-20.454 h -4.871 c -1.427,0.132 -1.558,0.779 -0.389,1.948 6.492,5.975 10.909,11.884 13.246,17.727 2.338,5.843 3.507,13.378 3.507,22.597 v 105.386 c 0,12.985 -0.651,21.493 -1.949,25.518 -2.988,8.311 -9.934,13.507 -20.843,15.585 -0.648,0.129 -0.974,0.454 -0.974,0.973 0,0.518 0.262,0.782 0.779,0.782 49.738,0.258 75.452,0.388 77.141,0.388 20.259,0.129 35.454,-5.456 45.583,-16.754",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(586.24392,904.23457)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 0.194,-20.454 H 33.7 v -20.454 c 0,-0.651 -0.262,-0.976 -0.78,-0.976 l -1.168,1.169 c -7.792,5.582 -17.469,8.377 -29.026,8.377 H 0 v -77.334 c 0,-25.843 -6.234,-38.767 -18.701,-38.767 h -27.857 c -0.517,0.132 -0.779,0.391 -0.779,0.781 0,0.52 0.262,0.845 0.779,0.974 6.492,1.948 10.842,6.622 13.052,14.025 1.687,5.323 2.532,13.114 2.532,23.375 0.259,44.933 0.196,69.087 -0.195,72.467 -0.778,8.44 -7.858,13.439 -21.232,14.999 -0.65,0 -0.974,0.322 -0.974,0.974 0,0.517 0.261,0.778 0.779,0.778 h 24.35 c 0.389,15.843 5.776,28.636 16.168,38.377 10.388,9.739 23.634,14.61 39.739,14.61 4.675,0 8.765,-1.593 12.273,-4.774 3.506,-3.183 5.258,-7.11 5.258,-11.784 0,-10.261 -6.299,-15.975 -18.895,-17.144 L 6.039,16.751 C 2.011,15.321 0,9.739 0,0",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(654.32592,924.20017)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.184,3.051 -4.773,6.915 -4.773,11.591 0,4.545 1.589,8.377 4.773,11.494 3.18,3.117 7.043,4.674 11.59,4.674 4.545,0 8.377,-1.591 11.494,-4.772 3.117,-3.185 4.675,-6.983 4.675,-11.396 0,-4.547 -1.558,-8.376 -4.675,-11.493 C 19.967,-3.019 16.135,-4.576 11.59,-4.576 7.043,-4.576 3.18,-3.053 0,0 m 52.304,-147.755 c 0,-0.52 -0.326,-0.779 -0.974,-0.779 l -73.635,-0.195 c -0.52,0.131 -0.779,0.454 -0.779,0.974 0,0.517 0.322,0.844 0.974,0.973 7.403,1.428 12.205,7.337 14.415,17.728 0.907,4.413 1.364,12.077 1.364,22.987 v 29.219 c 0,12.726 -0.716,21.166 -2.143,25.323 -2.857,8.311 -9.676,13.507 -20.454,15.584 -0.651,0.13 -1.041,0.454 -1.168,0.974 0,0.518 0.322,0.845 0.974,0.974 h 57.66 v -71.686 c 0,-12.855 0.712,-21.3 2.143,-25.323 2.855,-8.443 9.673,-13.702 20.454,-15.78 0.648,0 1.038,-0.324 1.169,-0.973",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(799.35621,854.16917)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -18.701,14.806 c -2.989,2.338 -6.106,2.985 -9.35,1.948 -7.275,-2.468 -10.976,-9.222 -11.104,-20.259 l -0.194,-32.143 c 0,-12.987 0.711,-21.493 2.142,-25.518 2.855,-8.313 9.804,-13.507 20.844,-15.585 0.648,-0.129 0.974,-0.456 0.974,-0.973 0,-0.52 -0.263,-0.842 -0.78,-0.974 h -71.686 c -0.517,0.132 -0.778,0.454 -0.778,0.974 0,0.517 0.325,0.844 0.973,0.973 7.402,1.428 12.206,7.337 14.416,17.728 0.906,4.545 1.363,12.336 1.363,23.375 v 30 c 0,12.856 -0.652,21.167 -1.948,24.935 -2.989,7.918 -9.935,12.919 -20.843,14.999 -0.649,0.127 -0.975,0.454 -0.975,0.974 0,0.517 0.262,0.778 0.78,0.778 h 55.518 V 13.441 c 5.713,15.585 17.531,23.378 35.453,23.378 1.818,0 3.765,-0.068 5.844,-0.195 5.193,-0.52 9.575,-2.47 13.149,-5.846 C 18.667,27.4 20.454,23.31 20.454,18.506 20.454,7.598 13.635,1.428 0,0",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(902.01209,872.67517)",
    style: {
      fill: "#cccccc"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -5.843,7.403 -12.729,11.106 -20.649,11.106 -14.414,0 -21.622,-10.198 -21.622,-30.586 0,-3.766 0.259,-7.727 0.779,-11.882 H 7.597 c 0.259,1.948 0.39,4.025 0.39,6.234 C 7.987,-15.389 5.323,-7.012 0,0 m 27.661,-46.751 -68.179,-0.195 c 1.817,-13.119 5.582,-23.18 11.298,-30.193 4.286,-5.064 10.647,-7.988 19.091,-8.767 15.973,-0.652 27.856,4.545 35.647,15.584 l 8.962,0.196 c -8.312,-19.871 -25.455,-29.805 -51.428,-29.805 -19.09,0 -33.441,5.455 -43.05,16.363 -9.223,10.388 -13.831,25.194 -13.831,44.415 0,19.09 4.608,33.827 13.831,44.218 9.868,11.037 24.219,16.558 43.05,16.558 17.791,0 31.656,-4.869 41.59,-14.608 9.935,-9.741 15.031,-23.507 15.292,-41.298 0.128,-8.314 -3.963,-12.468 -12.273,-12.468",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.a1e6449a5ff0eeb69eb8da7d8243a08b.svg";
export { ForwardRef as ReactComponent };